
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/temes",
      function () {
        return require("private-next-pages/3catinfo/temes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/temes"])
      });
    }
  